<div class="css-Boton_secundario-1 boton_secundario">
    <button [ngClass]="{'button_secundario':true, 'button_secundario-diff1':disabled}" class="button_secundario"
        [disabled]="disabled" (click)="ejecutarFuncion()">
        <p [ngClass]="{'texto_boton_secundario':true, 'texto_boton_secundario-diff1':disabled}">
            {{boton_texto}}
        </p>
    </button>
</div>